<template>
    <div v-if="unassignedPaymentDocuments.length > 0">
        <div class="mb-2">
            <button class="button is-danger" @click="show = !show">
                <span class="icon">
                    <i class="fa fa-exclamation-triangle" />
                </span>
                <span>
                    {{ translate("admin_payment.show_unassigned_documents", false, [unassignedPaymentDocuments.length]) }}
                </span>
                <span class="icon">
                    <i v-if="show" class="fa fa-caret-up" />
                    <i v-else class="fa fa-caret-down" />
                </span>
            </button>
        </div>

        <div v-if="show" class="box">
            <ul>
                <li v-for="payDoc in unassignedPaymentDocuments" :key="payDoc.id">
                    <a @click="onOpenPaymentDocument(payDoc.id)">{{ payDoc.name }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { eventBus, OPEN_PAYMENT_DOCUMENT } from "../eventBus";
    import urlsMixin from "../../Urls/urlsMixin";
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "unassigned-payment-documents",
        mixins: [urlsMixin, translatorMixin],
        props: ["eventId", "unassignedPaymentDocuments"],
        data() {
            return {
                show: false,
            };
        },
        methods: {
            onOpenPaymentDocument(paymentDocumentId) {
                const url = this.userEventPagesUrls().paymentDocumentDownload(this.eventId, paymentDocumentId, false);
                eventBus.$emit(OPEN_PAYMENT_DOCUMENT, url);
            },
        },
    };
</script>

<style scoped></style>
